import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/* A pharmacy product opens as a dialog over its storefront, and its address
   is the storefront's plus /product/<id> (src/utils/seoPaths.js). Opening or
   closing it changes the address but not the page, so the shopper must stay
   where they were in the catalogue instead of jumping back to the top. */
const DIALOG_ADDRESS = /^(\/healthcare\/shop\/[^/]+)\/product\/[^/]+\/?$/;
const pageOf = (pathname) => {
  const match = pathname.match(DIALOG_ADDRESS);
  return match ? match[1] : pathname;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const previous = useRef(pathname);

  useEffect(() => {
    const samePage = pageOf(previous.current) === pageOf(pathname);
    previous.current = pathname;
    if (samePage) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
